// extracted by mini-css-extract-plugin
export default {"heroheader":"HeroHeader_heroheader__tDGIE","logo":"HeroHeader_logo__11WcZ","actions":"HeroHeader_actions__FTYnw"};